import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { getEnvironmentProviders } from '@global/services/environment/environment-provider.service';
import { environment as env } from '@env/environment';
import { Environment } from '../models/environment';
import { Utility } from './utility';
import { MainModule as MainModuleMta } from '@app/main/main.module';
import { MainModule as MainModuleRen } from '@ren/main/main.module';

export class MainHelper {
  static setup() {
    const mainModule = Utility.isMta() ? MainModuleMta : MainModuleRen;
    const injector = Injector.create({
      providers: [getEnvironmentProviders],
    });
    const environment = injector.get(Environment);

    if (environment.production) {
      enableProdMode();
    }

    if (window.dlg_dolphin) {
      window.dlg_dolphin.brand = env.brand_copy.brand;
      window.dlg_dolphin.architecture = 'SPA';
      window.dlg_dolphin.type = 'Quote And Buy';
    }

    Utility.injectHeaderScripts(environment);

    platformBrowserDynamic()
      .bootstrapModule(mainModule)
      .catch((err) => console.error(err));
  }
}
